import { Controller } from '@hotwired/stimulus'
import validate from 'validate.js'
import { disableForm, enableForm } from '../src/helpers'

export default class extends Controller {
  static targets = ['input']

  connect () {
    validate.validators.presence.options = { allowEmpty: false }
    this.element.setAttribute('novalidate', true)
  }

  validate (event) {
    const formSubmission = event.detail.formSubmission

    disableForm(this.element)

    if (formSubmission.submitter.formNoValidate) {
      this.dispatch('skipped', { detail: { formSubmission: formSubmission } })
    } else {
      const errors = validate(this.element, this.constraints)

      if (errors) {
        const event = this.dispatch('invalid', { detail: { formSubmission: formSubmission, errors: errors } })
        if (event.defaultPrevented) return
        formSubmission.stop()
        this.showErrors(errors)
        setTimeout(() => enableForm(this.element), 100)
      } else {
        const event = this.dispatch('valid', { detail: { formSubmission: formSubmission } })
        if (event.defaultPrevented) {
          formSubmission.stop()
          return
        }
      }
    }
  }

  showErrors (errors) {
    this.inputTargets.forEach(input => this.showErrorsForInput(input, errors[input.name]))
    this.element.querySelector('.has-error').scrollIntoView({ behavior: 'smooth' })
  }

  get constraints () {
    return Object.fromEntries(
      this.inputTargets.map(input => [input.name, JSON.parse(input.getAttribute('data-validate'))])
    )
  }

  showErrorsForInput (input, errors) {
    this.clearErrors(input)

    const container = input.closest('.form-question')

    if (errors) {
      container.classList.add('has-error')
      this.insertErrorMessages(input, errors)
    } else {
      container.classList.remove('has-error')
    }
  }

  clearErrors (input) {
    if (document.getElementById(`error_${input.name}`) != null) {
      document.getElementById(`error_${input.name}`).remove()
    }
  }

  insertErrorMessages (input, errors) {
    const container = input.closest('.form-question')
    const html = `
      <div id="error_${input.name}" class="form-validation-error-message">
        ${errors.join(' ')}
      </div>
    `
    container.insertAdjacentHTML('afterend', html)
  }
}
